import './SuggestionsOverlay.css';
export var suggestionsOverlay = '_ssu5rt2-3-5-0';
export var suggestionsOverlayWrapper = '_ssu5rt1-3-5-0';
export var suggestionsOverlayWrapperContainer = '_ssu5rt0-3-5-0';
export var suggestionsScrollContainer = '_ssu5rt4-3-5-0';
export var suggestionsScrollContainerWrapper = '_ssu5rt3-3-5-0';